import React, { useEffect, useState } from "react";
import Head from "next/head";
import { ErrorPage } from "@themuse/design-system";

import { formatLog } from "utils/logging";
import { useUserState } from "../hooks/UserContext";
import { fetchJobRecommendations } from "../utils/api";

function Error() {
    const [recommendationCards, setRecommendationCards] = useState([]);
    const user = useUserState();

    useEffect(() => {
        const fetchRecommendedJobs = async () => {
            try {
                const response = await fetchJobRecommendations();
                setRecommendationCards(response.results.map((job) => ({
                    companyName: job.company_name,
                    jobTitle: job.name,
                    location: job.location_values[0],
                    companyLogoUrl: job.company_logo_image,
                    jobUrl: job.apply_link
                })));
            } catch (error) {
                const msg = `${process.env.APP_NAME} was unable fetch recommended jobs.`;
                console.error(msg, JSON.stringify(formatLog({ error })));
            }
        };

        fetchRecommendedJobs();
    }, []);
    /* eslint-disable max-len */
    return (
        <>
            <Head>
                <title key="title">Find The Best Jobs at Companies Hiring Now | The Muse</title>
                <meta key="description" name="description" content="Stars have aligned: I just found some awesome open jobs at Companies Hiring Now on The Muse. If you're looking for a new gig, check it out." />
                <meta key="og:title" property="og:title" content="Find The Best Jobs at Companies Hiring Now | The Muse" />
                <meta key="og:image" property="og:image" content="https://www.themuse.com/static/images/muse-og-image.png" />
                <meta key="og:description" property="og:description" content="Stars have aligned: I just found some awesome open jobs at Companies Hiring Now on The Muse. If you're looking for a new gig, check it out." />
                <meta key="robots" name="robots" content="noindex, follow" />
                <link rel="apple-touch-icon" sizes="180x180" href="https://public-assets.themuse.com/images/favicons/apple-touch-icon.png" />
                <link rel="icon" type="image/png" sizes="32x32" href="https://public-assets.themuse.com/images/favicons/favicon-32x32.png" />
                <link rel="icon" type="image/png" sizes="16x16" href="https://public-assets.themuse.com/images/favicons/favicon-16x16.png" />
                <link rel="manifest" href="https://public-assets.themuse.com/images/favicons/site.webmanifest" />
                <link rel="mask-icon" href="https://public-assets.themuse.com/images/favicons/safari-pinned-tab.svg" color="#9ADBF5" />
                <link rel="shortcut icon" href="https://public-assets.themuse.com/images/favicons/favicon.ico" />
                <meta name="apple-mobile-web-app-title" content="The Muse" />
                <meta name="application-name" content="The Muse" />
                <meta name="msapplication-TileColor" content="#9ADBF5" />
                <meta name="msapplication-config" content="https://public-assets.themuse.com/images/favicons/browserconfig.xml" />
                <meta name="theme-color" content="#9ADBF5" />
            </Head>
            <ErrorPage pageName="error-page" pageId="error-content" recommendationCards={recommendationCards} user={user} />
        </>
    );
}

export default Error;
